export class GetTotalItemRequest {
  keyword: string | null;
  exclusionWord: string | null;
  shouldSearchScopeControl: boolean;
  itemIconCodeList: string[];
  isFromSameToTwoDay: boolean;
  isDeliveryEstimate: boolean;
  shouldExcludeLargeSizeItem: boolean;
  priceRange: PriceRange | null;
  catalog: Catalog | null;
  isCbItem: boolean;

  // eslint-disable-next-line max-params
  constructor(
    keyword: string | null,
    exclusionWord: string | null,
    shouldSearchScopeControl: boolean,
    itemIconCodeList: string[],
    isFromSameToTwoDay: boolean,
    shouldExcludeLargeSizeItem: boolean,
    isDeliveryEstimate: boolean,
    priceRange: PriceRange | null,
    catalog: Catalog | null,
    isCbItem: boolean,
  ) {
    this.keyword = keyword;
    this.exclusionWord = exclusionWord;
    this.shouldSearchScopeControl = shouldSearchScopeControl;
    this.itemIconCodeList = itemIconCodeList;
    this.shouldExcludeLargeSizeItem = shouldExcludeLargeSizeItem;
    this.isDeliveryEstimate = isDeliveryEstimate;
    this.isFromSameToTwoDay = isFromSameToTwoDay;
    this.priceRange = priceRange;
    this.catalog = catalog;
    this.isCbItem = isCbItem;
  }
}

export class PriceRange {
  minPrice: string | null;
  maxPrice: string | null;

  constructor(minPrice: string | null, maxPrice: string | null) {
    this.minPrice = minPrice;
    this.maxPrice = maxPrice;
  }
}

export class Catalog {
  supplierId: string;
  catalogCode: string;

  constructor(supplierId: string, catalogCode: string) {
    this.supplierId = supplierId;
    this.catalogCode = catalogCode;
  }
}

export class ErrorMessage {
  title: string;
  content: string;

  constructor(title: string, content: string) {
    this.title = title;
    this.content = content;
  }
}
